import { Link } from "react-router-dom";

export default function NavbarComponent() {
	const handleSidebarToggler = () => {
		document.body.classList.toggle("sb-sidenav-toggled");
	};
	return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom">
			<div className="container-fluid">
				<button className="btn btn-primary" onClick={handleSidebarToggler}>
					Menu
				</button>
				<button
					className="navbar-toggler"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div>
					<ul className="navbar-nav ms-auto mt-2 mt-lg-0">
						<li className="nav-item dropdown">
							<button
								className="nav-link dropdown-toggle bg-light"
								id="navbarDropdown"
								data-bs-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								style={{ border: "none" }}>
								<img
									src="https://cdn0.iconfinder.com/data/icons/set-ui-app-android/32/8-512.png"
									width={"30px"}
									className="bg-dark rounded-circle"
									alt="post"
								/>
							</button>
							<div className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
								<button className="dropdown-item disabled">Hi, {localStorage.username}</button>
								<div className="dropdown-divider"></div>
								<Link to="/login" onClick={() => localStorage.clear()} className="dropdown-item">
									Sign out
								</Link>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
}
